import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=2c68eca6&scoped=true"
import script from "./historyRecord.vue?vue&type=script&lang=js"
export * from "./historyRecord.vue?vue&type=script&lang=js"
import style0 from "./historyRecord.vue?vue&type=style&index=0&id=2c68eca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68eca6",
  null
  
)

export default component.exports